import axios from 'axios';
import { postData } from '../../services/axiosUtils';

const tenantService = {
  list: () => {
    return axios.get(`/api/tenants/list`).then((response) => {
      return response.data;
    });
  },
  listMyTenants: () => {
    return axios.get(`/api/tenants/ListMyTenants`).then((response) => {
      return response.data;
    });
  },
  get: (id: any) => {
    return axios.get(`/api/tenants/details/${id}`).then((response) => {
      return response.data;
    });
  },
  create: (entity: any) => {
    return postData({
      url: `/api/tenants/create`,
      data: entity,
    }).then((response) => {
      return response;
    });
  },
  changeTenant: (entity: any) => {
    return postData({
      url: `/api/tenants/changeTenant`,
      data: entity,
    }).then((response) => {
      return response;
    });
  },
  update: (entity: any) => {
    return postData({
      url: `/api/tenants/update`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  delete: (id: any) => {
    return postData({
      url: `/api/tenants/delete/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
};

export default tenantService;
